<template lang="pug">
  .content.content-profile.white-fone
    .grid.wide
      p.vac-title {{ (offer.country || {}).short_name }}, {{(offer.region || {}).short_name}},&nbsp;
        | {{((offer.category || {}).name)}}, {{((offer.sector || {}).name)}},
        | {{((offer.profession || {}).name || offer.other_profession)}}{{((offer.profession || {}).name || offer.other_profession) ? ',' : ''}}
        | {{((offer.employment_type || {}).name)}}
      p.type
        span {{ gettext('Salary from') + ' ' }}
        span.red {{ offer.salary }} {{ ((offer.currency || [])[0] || {}).code }}
        span  {{ salaryTypeName(offer.salary_type) }}
        span.id {{ gettext('ID') }}: {{ offer.id }}
    .actions(v-if="getUser.id")
      .action-btn.red(v-if="getUser.profile_type === CONSTANTS.JOBSEEKER_PROFILE_TYPE" @click="openCVModal" :disabled="block") {{ gettext('Send CV') }}
      router-link.action-btn.red(v-if="getUser.profile_type === CONSTANTS.SENDER_PROFILE_TYPE" :to="{name: 'Dashboard', params: {lang: getLanguage}, query: {offer: offer.id}}") {{ gettext('Send CVS') }}
      .action-btn(v-if="getUser.profile_type === CONSTANTS.SENDER_PROFILE_TYPE || getUser.profile_type === CONSTANTS.JOBSEEKER_PROFILE_TYPE" @click="favoriteHandler") {{ !offer.is_wish ? gettext('Add to favorites') : gettext('Remove from favorites') }}
    .info-section
      .info-title {{ gettext('General Information') }}
      <!--.info-item(v-if="offer.is_partner")-->
        <!--p.type.partner {{ gettext('Partner') }}-->
      .info-item(v-if="offer.employment_type")
        div {{ gettext('Type of employment') }}
        span {{ offer.employment_type.name }}
      .info-item(v-if="offer.country")
        div {{ gettext('Country') }}
        span {{ offer.country.name }}
      .info-item(v-if="offer.region")
        div {{ gettext('Region') }}
        span {{ offer.region.name }}
      .info-item(v-if="offer.category")
        div {{ gettext('Category') }}
        span {{ offer.category.name }}
      .info-item(v-if="offer.sector")
        div {{ gettext('Sector') }}
        span {{ offer.sector.name }}
    .info-section(v-if="offer.responsibilities")
      .info-title {{ gettext('Responsibilities') }}
      .description
        pre {{offer.responsibilities}}
    .info-section(v-if="offer.description")
      .info-title {{ gettext('Qualification') }}
      .description
        pre {{offer.description}}
    .info-section(v-if="offer.contacts")
      .info-title {{ gettext('Contact Information') }}
      .info-item
        div {{ gettext('Phone') }}
        span {{ offer.phone }}
      .info-item
        div {{ gettext('Email') }}
        span {{ offer.email }}
      .info-item
        div {{ gettext('Skype') }}
        span {{ offer.skype }}
      .info-item
        div {{ gettext('Facebook') }}
        span {{ offer.facebook }}
    .info-section
      .info-title {{ gettext('Salary and Date') }}
      .info-item(v-if="offer.salary")
        div {{ gettext('Salary') }}  ({{((offer.currency || [])[0] || {}).code }})
        span {{ interpolate(gettext('%s %s %s '), [offer.salary, ((offer.currency || [])[0] || {}).code, salaryTypeName(offer.salary_type)])}}
      .info-item(v-if="offer.start_date")
        div {{ gettext('Start date') }}
        span {{ moment(offer.start_date).format('DD/MM/YYYY') }}
      .info-item(v-if="offer.trial_period_mon")
        div {{ gettext('Trial period') }}
        span {{ offer.trial_period_mon }} {{ gettext('months') }}
      .info-item(v-if="offer.work_hours_week")
        div {{ gettext('Working hours per week') }}
        span {{ offer.work_hours_week }}
    .info-section(v-if="offer.country_visibility === CONSTANTS.COUNTRY_VISIBILITY_LOCAL")
    .info-section(v-else)
      .info-title {{ gettext('Additional Information') }}
      .info-item
        div {{ gettext('Accept couples') }}
        span {{ offer.accept_couples ? gettext('Yes') : gettext('No') }}
      .info-item
        div {{ gettext('Food provided') }}
        span {{ offer.food ? gettext('Yes') : gettext('No') }}
      .info-item
        div {{ gettext('Accommodation provided') }}
        span {{ offer.accommodation ? gettext('Yes') : gettext('No')}}

    .field(v-if="getUser.profile_type === CONSTANTS.JOBSEEKER_PROFILE_TYPE")
      .field-body
        button.main-btn.col-white.bg-red(@click="openCVModal" :disabled="block") {{ gettext('Send CV') }}
    .field(v-else-if="getUser.profile_type === CONSTANTS.EMPLOYER_PROFILE_TYPE")
    .field(v-else-if="getUser.profile_type === CONSTANTS.SENDER_PROFILE_TYPE")
      .field-body
        router-link.main-btn.col-white.bg-red(:to="{name: 'Dashboard', params: {lang: getLanguage}, query: {offer: offer.id}}") {{ gettext('Send CVS') }}
    .field(v-else)
      .field-body
        button.main-btn.col-white.bg-red(@click="showAuthModal = true") {{ gettext('Send CV') }}

    v-modal(:show.sync="showAuthModal" :clickAway="true")
      section.modal-card-body
        .is-size-4.has-text-centered.title {{ gettext('Log in your profile or sign up') }}!
        .btn-wrap
          router-link.main-btn.col-white.bg-red.nav-item.is-tab(:to="{name: 'Registration', params: {lang: getLanguage}, hash: '#employees'}") {{ gettext('Register') }}
          router-link.main-btn.col-white.bg-black.nav-item.is-tab(:to="{name: 'Login', params: {lang: getLanguage}}") {{ gettext('Log in') }}
    v-modal.cv-modal(:show.sync="showCVSModal" :clickAway="true")
      header.modal-card-head
        .is-size-4.has-text-centered.modal-card-title {{ gettext('Select CV') }}
        button.delete(@click="showCVSModal = false")
      section.modal-card-body
        cv-select(@selected="cvSelected")
      footer.modal-card-foot
    v-modal(:show.sync="showThanksModal" :clickAway="true")
      section.modal-card-body
        | {{ gettext('Thank you. We have received your application. We will let you know if you are invited to an interview. Thank you for your application, and have a nice day.') }}

</template>
<script>
import { gettext, interpolate, ngettext } from '@/services/TranslateHandler'
import { mapGetters, mapActions } from 'vuex'
import Contacts from './parts/contacts'
import CONSTANTS from '@/constants'
import VModal from '@/components/modal'
import CvSelect from './components/cv-select'

const moment = require('moment')
const toastr = require('toastr')

export default {
  name: 'Offer',
  components: {
    Contacts,
    VModal,
    CvSelect
  },
  filters: {
    date: function (val, format = 'DD/MM/YYYY') {
      return moment(val).format(format)
    }
  },
  data () {
    return {
      CONSTANTS: CONSTANTS,
      block: false,
      showAuthModal: false,
      showCVSModal: false,
      showThanksModal: false,
      employer: (this.$store.getters.getUser || {}).profile_type === 20,
      moment: moment
    }
  },
  methods: {
    gettext: gettext,
    ...mapActions([
      'sendCvToJoboffer',
      'addVacancyTofavorites',
      'deleteVacancyFromfavorites'
    ]),
    interpolate: interpolate,
    ngettext: ngettext,
    cvSelected (item) {
      this.showCVSModal = false
      this.sendCV(item)
    },
    openCVModal () {
      if (this.$store.state.userHasCV) {
        this.showCVSModal = true
      } else {
        toastr.warning(gettext('Create CV first'), gettext('Warning!'))
      }
    },
    favoriteHandler () {
      if (this.offer.is_wish) {
        this.deleteVacancyFromfavorites({id: parseInt(this.$route.params.id)}).then(res => {
          if (res.success) {
            this.offer.is_wish = false
          }
        })
      } else {
        this.addVacancyTofavorites({id: parseInt(this.$route.params.id)}).then(res => {
          if (res.success) {
            this.offer.is_wish = true
          }
        })
      }
    },
    sendCV (cv) {
      if (cv) {
        this.sendCvToJoboffer({
          lang: this.getLanguage,
          cv: [parseInt(cv.id)],
          offer: parseInt(this.$route.params.id)
        }).then((res) => {
          if (res.items[0].is_already_sent) {
            let diff = moment(res.items[0].avail_request_dt).diff(res.items[0].current_request_dt, 'days')
            toastr.warning(
              interpolate(
                ngettext(
                  'For this offer you will be able to send the CV only after %s (%s day left)',
                  'For this offer you will be able to send the CV only after %s (%s days left)',
                  diff
                ),
                [moment(res.items[0].avail_request_dt).format('DD/MM/YYYY'), diff]
              ),
              gettext('Warning!')
            )
          } else if (res.items[0].daily_limit_reached) {
            toastr.info(interpolate(gettext('You have already used your daily limit (%s per day)!'), [res.items[0].daily_requests_limit]), gettext('Warning!'))
          } else if (!res.items[0].sent) {
            toastr.info(res.items[0].message, gettext('Warning!'))
          } else if (res.success) {
            this.showThanksModal = true
            toastr.success(gettext('You CV successfully send.'), gettext('Success!'))
            this.block = true
          } else {
            toastr.error(gettext('Something gone wrong. Please try later or connect with support team'), gettext('Error!'))
          }
        })
      }
    },
    salaryTypeName (code) {
      let types = {
        [CONSTANTS.SALARY_PER_HOUR]: gettext('per hour'),
        [CONSTANTS.SALARY_PER_DAY]: gettext('per day'),
        [CONSTANTS.SALARY_PER_WEEK]: gettext('per week'),
        [CONSTANTS.SALARY_PER_MONTH]: gettext('per month')
      }
      if (code) return types[code]
      return types[CONSTANTS.SALARY_PER_HOUR]
    }
  },
  props: {
    offer: {
      default: () => {
        return {}
      }
    },
    allCategories: {
      default () {
        return []
      }
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getUser'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/vacancy/parts/offer/index.vue